import { render, staticRenderFns } from "./lockPrice.vue?vue&type=template&id=b6ae6d76&scoped=true"
import script from "./lockPrice.vue?vue&type=script&lang=js"
export * from "./lockPrice.vue?vue&type=script&lang=js"
import style0 from "./lockPrice.vue?vue&type=style&index=0&id=b6ae6d76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ae6d76",
  null
  
)

export default component.exports